import { useChatsStore } from "@/store/useChatsStore";
import { EntryDtoType } from "@saysimple-platform/dtos";
import { computed } from "@vue/composition-api";

export default function useQuotedEntryJump() {
    const { activeChat } = useChatsStore();

    // Those are the entries that are quoted to and is "part" of an original entry. It's the quoted message in the the "quote box".
    const quotedEntryIds = computed(() => {
        // @note before conversations layer migration, it was "replyToMessageId", that has become "replyToEntryId", but records are not migrated, so we'll support both
        return activeChat.entries
            .filter((entry: EntryDtoType) => entry.metadata?.replyToEntryId || entry.metadata?.replyToMessageId)
            .map((quotedEntry) => Number(quotedEntry.metadata.replyToEntryId || quotedEntry.metadata.replyToMessageId));
    });

    // Those are the original entries (most parent - the reply on a quote - the entry not in the "quot box").
    const originalEntryIds = computed(() => {
        return activeChat.entries
            .filter((entry: EntryDtoType) => quotedEntryIds.value.includes(entry.id))
            .map((originalEntry) => originalEntry.id);
    });

    // When lazy loading more entries, this may become true reactively. You can use this to show/hide elements for example.
    const isQuotedEntryAvailable = (quotedEntryId: number) => {
        return originalEntryIds.value.some((entryId) => entryId === quotedEntryId);
    };

    return {
        quotedEntryIds,
        originalEntryIds,
        isQuotedEntryAvailable,
    };
}
